<template>
  <section>
    <div style="background-color:#000;padding:15px 15px;color:#fff">Account Contact Information</div>
    <div style="background-color:#e8e6e6;padding:25px 15px">
        <v-form
        ref="form"
            v-model="awsAccountContact.awsContactValid"
            lazy-validation
          >
      <v-container
        fluid
        style="padding:0">
        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm12
            md6
            xl6>
            <div>Account Owners:</div>
            <div style="margin-right:25px">Enter at least 2 DXC contacts for this account. This will be DXC employees responsible for the overall AWS account. DXC eMail Distributions Lists may be used only for the second contact. The first contact must be a DXC named employee, email, and phone.</div>
          </v-flex>
          <v-flex
            xs12
            sm12
            md6
            xl6>
            <v-layout
              row
              wrap>
              <v-flex
                xs12
                sm12
                md12
                xl12>
                <v-text-field
                  v-model="awsAccountContact.acctOwner.name"
                  class="centered-input"
                  placeholder="Name"
                  solo/>
              </v-flex>
              <v-flex
                xs12
                sm12
                md6
                xl6>
                <v-text-field
                  v-model="awsAccountContact.acctOwner.phone"
                  class="centered-input"
                  placeholder="Phone Number"
                  solo/>
              </v-flex>
              <v-flex
                xs12
                sm12
                md6
                xl6>
                <v-text-field
                  v-model="awsAccountContact.acctOwner.email"
                  class="centered-input"
                  placeholder="Email Address"
                  solo/>
              </v-flex>
              <v-flex
                xs12
                sm12
                md12
                xl12>
                <v-layout
                  align-top
                  justify-end
                  style="margin-top:-25px">
                  <v-btn
                    class="opp-btn"
                    color="warning"
                    @click="add">Add Account Owner</v-btn>
                  <!-- <v-btn
                    class="opp-btn"
                    color="warning"
                    @click="view">View Account Owner</v-btn> -->
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-flex xs12 sm12 md12 xl12>
          <div style="padding:15px 25px; margin: 15px 0">
              <v-dialog v-model="awsAccountContact.editDialog" max-width="500px">                   
                  <v-card>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12 xl12>
                            <v-text-field v-model="awsAccountContact.acctOwner.name" label="Name"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12 xl12>
                            <v-text-field v-model="awsAccountContact.acctOwner.phone" label="Phone"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md4 xl12>
                            <v-text-field v-model="awsAccountContact.acctOwner.email" label="Email"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
             </v-dialog>
             <v-data-table
              :headers="awsAccountContact.accountOwnersHeaders"
              :items="awsAccountContact.Account_Owners"
              :items-per-page="2"
              class="elevation-1"
             >
             <template v-slot:items="props">
               <td>
                 <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                 <v-icon small @click="deleteItem(props.item )">delete</v-icon>
               </td>
               <td>{{ props.item.name }}</td>
               <td>{{ props.item.phone }}</td>
               <td>{{ props.item.email }}</td>
             </template>
             <template v-slot:no-data>
             </template>
             </v-data-table>
          </div>
        </v-flex>
        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm12
            md6
            xl6>Please provide a list of users who will receive notifications from AWS on account usage:</v-flex>
          <v-flex
            xs12
            sm12
            md6
            xl6>

              <template>
                <v-combobox v-model="notificationList"
                            label="Emails"
                            chips
                            clearable
                            solo
                            :rules="emailRules"
                            multiple>
                    <template v-slot:selection="data">
                        <v-chip :selected="data.selected"
                                close
                                @input="notificationListRemove(data.item)">
                            <strong>{{ data.item }}</strong>&nbsp;
                        </v-chip>
                    </template>
                </v-combobox>
            </template>
          </v-flex>
        </v-layout>
        <v-layout
          v-if="awsAccountOnboarding.fields.Managed_Svc !== 'DXC Gold'"
          row
          wrap>
          <v-flex
            xs12
            sm12
            md6
            xl6>Please provide a list of users for the account who need Admin access:</v-flex>
          <v-flex
            xs12
            sm12
            md6
            xl6>

            <template>
                <v-combobox v-model="iAmUsers"
                            label="Emails"
                            chips
                            clearable
                            solo
                            :rules="emailRules"
                            multiple>
                    <template v-slot:selection="data">
                        <v-chip :selected="data.selected"
                                close
                                @input="iAmUsersRemove(data.item)">
                            <strong>{{ data.item }}</strong>&nbsp;
                        </v-chip>
                    </template>
                </v-combobox>
            </template>

          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12 sm12 md6 xl6>
            Who is the financial owner of the AWS account (owner of WBS / IWO associated with it)?
          </v-flex>
          <v-flex xs12 sm12 md6 xl6>
            
            <template>
                <v-combobox v-model="financeOwners"
                            label="Emails"
                            chips
                            clearable
                            solo
                            :rules="emailRules"
                            multiple>
                    <template v-slot:selection="data">
                        <v-chip :selected="data.selected"
                                close
                                @input="financeOwnersRemove(data.item)">
                            <strong>{{ data.item }}</strong>&nbsp;
                        </v-chip>
                    </template>
                </v-combobox>
            </template>


          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap>
          <v-layout
            column
            wrap
            align-center
            justify-center>
            <v-flex
              xs12
              sm12
              md12
              xl12>
              <v-btn
                v-if="awsAccountContact.submitted===false"
                class="opp-btn"
                value="true"
                @click="goBack"> Go Back to Previous Page</v-btn>
              <!-- <v-btn class="opp-btn" color="warning" v-if="awsAccountContact.submitted" @click="onReset">Reset</v-btn> -->
              <v-btn
                :disabled="awsAccountContact.submitted || !validContacts ||!awsAccountContact.awsContactValid"
                :loading="awsAccountContact.submitting"
                class="opp-btn"
                color="warning"
                @click="submitReqContact">Submit</v-btn>
            </v-flex>
          </v-layout>
        </v-layout>

        <!-- VIEW ALL ACCOUNT OWNERS -->
        <v-dialog
          v-model="viewAccountOwners"
          persistent
          max-width="600px">
          <v-card>Monthly Cross Charge
            <v-card-title>
              <span class="headline">View Account Owners</span>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="acctOwnerTableHeader"
                :items="awsAccountContact.Account_Owners"
              >
                <template
                  slot="headerCell"
                  slot-scope="{ header }">
                  <span
                    class="subheading font-weight-light text-success text-md-left text--darken-3"
                    v-text="header.text"
                  />
                </template>
                <template v-slot:items="props">
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.phone }}</td>
                  <td>{{ props.item.email }}</td>

                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"/>
              <v-btn
                color="orange darken-1"
                text
                @click="viewAccountOwners = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Success Contact -->
        <v-dialog
          v-model="awsAccountContact.contactStatus"
          persistent
          max-width="600px">
          <v-card>
            <v-card-text>
              <div style="font-weight:500"> {{ awsAccountContact.contactStatusMsg }}</div>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"/>
              <v-btn
                color="orange darken-1"
                text
                @click=" awsAccountContact.contactStatus = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
        </v-form>
    </div>
  </section>
</template>
<script>
import { METHODS } from 'http'
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import { getCountries } from '@/utils/helper'
export default {
  props: ['type'],
  data: () => ({
    activator: null,
    attach: null,
    colors: ['gray'],
    editing: null,
    index: -1,
    items: [{ header: 'Select an option or create one' }],
    nonce: 1,
    menu: false,
    model: [],
    acctOwners: [],
    cloudCheckr: [],
    notificationList: [],
    iAmUsers: [],
    financeOwners:[],
    viewAccountOwners: false,
    x: 0,
    search: null,
    y: 0,
    chips: [],
    emailRules :[
      v => {
        if (!v || v.length < 1)
          return 'Input is required';
        else if (v.length > 0) {
          for (let i = 0; i < v.length; i++) {
                if (!(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v[i]))) {
                return 'Input must be valid email format';
              }
            }
          }
        else return true;
      }
    ]
  }),
  computed: {
    ...mapState('user/requestAws', [
      'awsAccountOnboarding',
      'awsAccountContact',
      // "workload",
      'showRequestAwsQuestionnaire',
      'showRequestAwsContacts',
      'acctOwnerTableHeader',
      'newAwsAcctInternalClient',
      's3FileUpload'
    ]),
    validContacts () {
      if (this.awsAccountOnboarding.fields.Managed_Svc !== 'DXC Gold') {
        return this.awsAccountContact.Account_Owners.length &&
        // this.cloudCheckr.length &&
        this.notificationList.length &&
        this.iAmUsers.length &&
        this.financeOwners.length
      } else {
        return this.awsAccountContact.Account_Owners.length &&
        // this.cloudCheckr.length &&
        this.notificationList.length &&
        this.financeOwners.length
      }
    }
  },
  watch: {
    acctOwners (val, prev) {
      if (val.length === prev.length) return
      this.acctOwners = val.map(v => {
        if (typeof v === 'string') {
          v = {
            text: v
            // color: this.colors[0]
          }

          this.items.push(v)

          this.nonce++
        }

        return v
      })
    },

    cloudCheckr (val, prev) {
      if (val.length === prev.length) return
      this.cloudCheckr = val.map(v => {
        if (typeof v === 'string') {
          v = {
            text: v,
            color: this.colors[0]
          }
          this.cloudCheckr.push(v)
          this.items.push(v)
          this.nonce++
        }
        return v
      })
    },

  },
  beforeDestroy () {
    // this.$emit('reset')
  },

  mounted () {
    if (this.newAwsAcctInternalClient.accountRecord.onboarding.Financial_Owner.length) {
      this.populateInitialFinancialOwners()
    }
  },

  methods: {
    ...mapActions({
      submitAwsContact: 'user/requestAws/saveContacts'
    }),
    edit (index, item) {
      if (!this.editing) {
        this.editing = item
        this.index = index
      } else {
        this.editing = null
        this.index = -1
      }
    },
    filter (item, queryText, itemText) {
      if (item.header) return false

      const hasValue = val => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      )
    },
    add () {
      let acctOwnerObject = {
        name: this.awsAccountContact.acctOwner.name,
        phone: this.awsAccountContact.acctOwner.phone,
        email: this.awsAccountContact.acctOwner.email
      }

      let accountOwnerArray = this.awsAccountContact.Account_Owners

      let isAccountOwnerExists = accountOwnerArray.filter(res => {
        return res.email === this.awsAccountContact.acctOwner.email
      })

      if (isAccountOwnerExists.length === 0) {
        accountOwnerArray.push(acctOwnerObject)
        this.awsAccountContact.acctOwner.name = ''
        this.awsAccountContact.acctOwner.phone = ''
        this.awsAccountContact.acctOwner.email = ''
      } else {
        this.$store.commit(
          'showDialog',
          {
            show: true,
            type: 'alert',
            persistent: true,
            title: 'Email Already Exists!'
          },
          { root: true }
        )
      }

      this.awsAccountContact.acctOwner.name = ''
      this.awsAccountContact.acctOwner.phone = ''
      this.awsAccountContact.acctOwner.email = ''
    },
    editItem (item) {
        this.awsAccountContact.editedIndex = this.awsAccountContact.Account_Owners.indexOf(item)
        this.awsAccountContact.acctOwner = Object.assign({}, item)
        this.awsAccountContact.editDialog = true
    },

    deleteItem (item) {
        const index = this.awsAccountContact.Account_Owners.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.awsAccountContact.Account_Owners.splice(index, 1)
      },

    close () {
        this.awsAccountContact.editDialog = false
        setTimeout(() => {
          let defaultItem= {
            name: '',
            phone: '',
            email: ''
          }
          this.awsAccountContact.editedIndex = -1
        }, 300)
      },

    save () {
        if (this.awsAccountContact.editedIndex > -1) {
          Object.assign(this.awsAccountContact.Account_Owners[this.awsAccountContact.editedIndex], this.awsAccountContact.acctOwner)
        } else {
          this.awsAccountContact.Account_Owners.push(this.awsAccountContact.acctOwner)
        }
        this.close()
      },
    async submitReqContact () {
      if (this.s3FileUpload.item) {
        await this.$store.dispatch('user/requestAws/uploadToS3AndAddFileNameToPayload', this.s3FileUpload.item);
      }
      if (this.awsAccountOnboarding.fields.Internal_Individual_Training === 'Bulk Training')
      await this.$store.dispatch('user/requestAws/sendEmailToManager', {
        managerEmail: this.awsAccountOnboarding.fields.Manager_Email,
        s3KeyName: this.newAwsAcctInternalClient.accountRecord.onboarding.S3_Filename
      });
      this.$emit('save', {
        accountOwners: this.awsAccountContact.Account_Owners,
        cloudchekrUsers: this.cloudCheckr,
        iamUsers: this.iAmUsers,
        notificationList: this.notificationList,
        financeOwners: this.financeOwners
      })
    },
    onReset () {
      this.$emit('reset')
    },
    goBack () {
      console.log('Go back!')
      this.$emit('go-to-onboarding')
    },


    // chips COMBO BOX
    notificationListRemove(item) {
                this.notificationList.splice(this.notificationList.indexOf(item), 1)
                this.notificationList = [...this.notificationList]
            },

    iAmUsersRemove(item) {
                this.iAmUsers.splice(this.iAmUsers.indexOf(item), 1)
                this.iAmUsers = [...this.iAmUsers]
            },
    financeOwnersRemove(item) {
                this.financeOwners.splice(this.financeOwners.indexOf(item), 1)
                this.financeOwners = [...this.financeOwners]
            },
    
    populateInitialFinancialOwners() {
      this.financeOwners = [...this.financeOwners, ...this.newAwsAcctInternalClient.accountRecord.onboarding.Financial_Owner]
    }

  }
}
</script>
<style lang="scss" scoped>
.v-autocomplete__content.v-menu__content {
  left: 50% !important;
}
.centered-input input {
  text-align: center
}
</style>
